function LogoMarkAldysWhite() {
  return (
    <svg width="92" height="24" viewBox="0 0 92 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.96283 13.5749V14.8197H11.183C13.6115 14.8197 18.5558 10.3987 18.5558 4.98141V3.73606H12.2045C7.53439 3.73606 3.73606 7.90799 3.73606 14.8197V18.5558H0V13.948C0 7.47212 4.421 0 12.1422 0H22.2918V4.98141C22.2918 11.1459 17.3727 18.5558 11.183 18.5558H6.22677V14.8197C6.22677 9.21562 9.15335 6.22677 12.2045 6.22677H15.9637C15.9637 7.22305 15.3013 8.84201 14.6597 9.48364C12.329 9.48364 9.96283 10.9342 9.96283 13.5749Z"
        fill="#29A383"
      />
      <path
        d="M45.3001 18.5492H40.7949L39.6547 15.4067H31.7011L30.533 18.5492H26.0278L33.2028 0H38.153L45.3001 18.5492ZM38.5701 11.9305L35.6779 3.94902L32.7857 11.9305H38.5701Z"
        fill="white"
      />
      <path d="M49.859 18.5492H46.3271V0H49.859V18.5492Z" fill="white" />
      <path
        d="M64.8966 18.5492H61.3369V16.825C60.2801 18.1599 58.8062 18.883 57.1932 18.883C53.8004 18.883 51.2419 16.3244 51.2419 11.847C51.2419 7.45307 53.7726 4.78331 57.1932 4.78331C58.7784 4.78331 60.2801 5.47856 61.3369 6.84125V0H64.8966V18.5492ZM58.2778 15.7404C59.4736 15.7404 60.7529 15.1008 61.3369 14.2109V9.45539C60.7529 8.56547 59.4736 7.92584 58.2778 7.92584C56.2755 7.92584 54.885 9.51101 54.885 11.847C54.885 14.1553 56.2755 15.7404 58.2778 15.7404Z"
        fill="white"
      />
      <path
        d="M67.3699 23.8053L67.8983 20.635C68.2042 20.774 68.677 20.8575 69.0107 20.8575C69.9284 20.8575 70.5403 20.6072 70.874 19.8841L71.3745 18.7439L65.9238 5.11703H69.706L73.21 14.4612L76.7141 5.11703H80.524L74.2112 20.7462C73.21 23.2769 71.4302 23.9444 69.1219 24C68.7048 24 67.8149 23.9166 67.3699 23.8053Z"
        fill="white"
      />
      <path
        d="M86.0099 18.883C83.6738 18.883 81.4212 18.1043 80.0029 16.7972L81.5324 14.3221C82.5058 15.2399 84.5081 16.1576 86.1767 16.1576C87.7063 16.1576 88.4293 15.5458 88.4293 14.7115C88.4293 12.4867 80.4479 14.2943 80.4479 9.01043C80.4479 6.75782 82.4224 4.78331 85.9542 4.78331C88.2346 4.78331 90.0423 5.56199 91.3772 6.61877L89.9589 9.03824C89.1524 8.17613 87.6228 7.48088 85.982 7.48088C84.7028 7.48088 83.8685 8.06489 83.8685 8.81576C83.8685 10.8181 91.8221 9.14948 91.8221 14.5724C91.8221 17.0197 89.7364 18.883 86.0099 18.883Z"
        fill="white"
      />
    </svg>
  );
}

export default LogoMarkAldysWhite;
